<template>
    <div>
        <Search @search='pageInfor.pageNo=1;goodsList()' @reset="pageInfor.pageNo=1;reset()">
            <div class="search_box" slot="one">
                <div class="search_items">
                    &nbsp;&nbsp;商品名称：
                    <input v-model.trim="searchParams.containsWord" type="text" class="public_input">
                </div>
                <div class="search_items">
                    商品 ID：
                    <input v-model.trim="searchParams.itemId" type="text" class="public_input">
                </div>
                <div class="search_items">
                    活动类型：
                    <Select class="search_select" v-model="searchParams.singlePromotion">
                            <Option :value="item.value" v-for="item,index in promotionTypeList" :key="index">{{item.label}}</Option>  
                        </Select>
                </div>
            </div>
        </Search>
        <Table class="choosegoods_modal_table" :height='380' :columns='tableColumns' :data='dataList.records' @on-current-change='highLightRowChange' highlight-row></Table>
        <div class="page">
            <Page :total="dataList.totalCount" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageInfor.pageSize" :current="pageInfor.pageNo" show-elevator show-sizer placement='top' size='small'></Page>
        </div>
        <div class="matterManage_btn_box matterManage_btn_box_center">
            <div class="matterManage_btn" @click="$emit('hasChoosedGoods',choosedColumns)">确定</div>
            <div class="matterManage_btn matterManage_btn_reset" @click="$emit('cancelGoods',choosedColumns)">取消</div>
        </div>
    </div>
</template>
<script>
    import matterManageApi from "@/api/matterManage";
    import Search from '@/components/search/search.vue';
    export default {
        data() {
            return {
                searchParams: {
                    itemId: null,
                    /* 商品id	array<number> */
                    containsWord: null,
                    /* 商品名称包含的关键字	string */
                    singlePromotion: null,
                    /* 商品参加的活动类型（17-阶梯拼团、19-自购省分享赚）	number */
                },
                /* 搜索条件 */
                dataList: {
                    records: []
                },
                /* 表格的数据 */
                choosedColumns: [],
                /* 选择的商品 */
                tableColumns: [{
                        title: '商品 ID',
                        key: 'itemId',
                        align: "center",
                        width: 180,
                        render: (h, params) => {
                            return h('a', {
                                attrs: {
                                    'target':'_blank',
                                    'href': this.$api.frontEndRequestUrl + '/#/goodsDetails/' + params.row.itemId
                                },
                                style: {
                                    'color': '#6236FF',
                                    'cursor': 'pointer'
                                }
                            }, params.row.itemId)
                        },
                    }, {
                        title: '商品信息',
                        key: '',
                        align: "center",
                        render: (h, params) => {
                            return h('div', [
                                h('span', {
                                    style: {
                                        'display': 'inline-block',
                                        'width': '80px',
                                        'height': '80px',
                                        'margin': '10px 0',
                                        'vertical-align': 'middle'
                                    }
                                }, [
                                    h('img', {
                                        attrs: {
                                            'src': this.imgUrl + params.row.pictureName
                                        },
                                        style: {
                                            'width': '100%',
                                            'height': '100%'
                                        }
                                    })
                                ]),
                                h('span', {
                                    style: {
                                        'width': '220px',
                                        'display': 'inline-block',
                                        'vertical-align': 'middle'
                                    }
                                }, params.row.itemName)
                            ])
                        }
                    },
                    {
                        title: '叶子类目',
                        key: 'backName',
                        align: "center",
                    },
                    {
                        title: '店铺名称',
                        key: 'storeName',
                        align: "center",
                        width: 180
                    },
                    {
                        title: '价格信息',
                        key: 'minPrice',
                        align: "center",
                        width: 180
                    },
                ],
                promotionTypeList: [{ /* 活动类型列表 */
                    value: '',
                    label: '全部'
                }, {
                    value: 19,
                    label: '自购省分享赚'
                }, {
                    value: 17,
                    label: '免费开团'
                }, ],
                pageInfor: {
                    pageNo: 1,
                    pageSize: 10,
                }
            }
        },
        methods: {
            goodsList() {
                matterManageApi.goodsList(this.searchParams, this.pageInfor).then(res => {
                    if (res.data.code == '200') {
                        this.dataList = res.data.data
                    } else {
                        this.$Message.error(res.data.message)
                    }
                })
            },
            highLightRowChange(current) {
                this.choosedColumns.splice(0);
                this.choosedColumns.push(current)
            },
            reset() {
                for (let item in this.searchParams) {
                    this.searchParams[item] = ''
                }
                this.goodsList()
            },
            pageChange(pageNo) {
                this.pageInfor.pageNo = 1;
                this.$nextTick(() => {
                    this.goodsList()
                })
            },
            pageSizeChange(pageSize) {
                this.pageInfor.pageSize = 10;
                this.$nextTick(() => {
                    this.goodsList()
                })
            }
        },
        mounted() {
            this.goodsList()
        },
        components: {
            Search
        }
    }
</script>
<style scoped>
    @import '../index.css';
    .page {
        margin: 0
    }
</style>